import ctcReader from '@vp/ctc-reader';

const addCtcReaderTreatments = function(customerGroups) {
  try {
    const treatments = ctcReader.getAllTreatments();
    if (customerGroups) {
      return [
        .../* @__PURE__ */ new Set([...customerGroups, ...treatments])
      ];
    } else {
      return treatments;
    }
  } catch (e) {
    console.log(`treatment initialization failed on: ${e.message}`);
  }
  return customerGroups;
};

export { addCtcReaderTreatments };
//# sourceMappingURL=web-ctc.js.map
